import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

fetch('/api/auth/config')
  .then((response) => response.json())
  .then((config) => {
    bootstrapApplication(AppComponent, appConfig(config)).catch((err) =>
      console.error(err),
    );
  });
